import React from "react";

const ExitConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto">
      {/* Overlay avec flou et dégradé */}
      <div className="fixed inset-0 bg-gradient-to-br from-slate-900/95 via-indigo-900/90 to-slate-900/95 backdrop-blur-md transition-opacity" />

      {/* Modal centré */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-3xl bg-white shadow-2xl transition-all animate-fadeIn">
          {/* Décoration supérieure */}
          <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-amber-400 via-orange-500 to-red-500" />

          {/* Contenu */}
          <div className="px-8 pt-10 pb-8 text-center">
            {/* Icône d'avertissement animée */}
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-amber-50 to-orange-100 mb-6 animate-pulse">
              <div className="relative">
                <svg
                  className="w-10 h-10 text-orange-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
                {/* Points d'exclamation animés */}
                <span className="absolute -top-1 -right-1 flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-500"></span>
                </span>
              </div>
            </div>

            {/* Titre */}
            <h3 className="text-2xl font-black text-slate-800 mb-3">
              ¿Abandonar el examen?
            </h3>

            {/* Message */}
            <div className="space-y-2 mb-8">
              <p className="text-slate-600 text-lg">¡Tu progreso se perderá!</p>
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-700">
                <div className="flex items-start gap-3">
                  <svg
                    className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="font-medium">
                    Las respuestas que has marcado no se guardarán y tendrás que
                    comenzar desde el principio.
                  </span>
                </div>
              </div>
            </div>

            {/* Boutons d'action */}
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={onConfirm}
                className="flex-1 px-6 py-4 bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white font-black rounded-2xl shadow-lg shadow-orange-200 transition-all transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Sí, salir
              </button>

              <button
                onClick={onCancel}
                className="flex-1 px-6 py-4 bg-white border-2 border-slate-200 hover:border-blue-300 hover:bg-blue-50 text-slate-700 hover:text-blue-600 font-bold rounded-2xl transition-all flex items-center justify-center gap-2 group"
              >
                <svg
                  className="w-5 h-5 text-slate-400 group-hover:text-blue-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                Continuar examen
              </button>
            </div>

            {/* Message discret */}
            <p className="mt-6 text-xs text-slate-400">
              Tu progreso se restablecerá si sales ahora
            </p>
          </div>
        </div>
      </div>

      {/* Styles d'animation */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .scale-in-center {
            animation: scale-in-center 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
          }
          @keyframes scale-in-center {
            0% { transform: scale(0); opacity: 1; }
            100% { transform: scale(1); opacity: 1; }
          }
        `,
        }}
      />
    </div>
  );
};

export default ExitConfirmationModal;
